import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-1 min-h-0 w-full pr-x3" }

import SearchField from '@/shared/search/ui/SearchField.vue';
import SearchResult from '@/shared/search/ui/SearchResult.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchArea',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SearchField),
    _createVNode(SearchResult)
  ]))
}
}

})